import _uniqueId from 'lodash.uniqueid';

export function uniqueId(prefix?: string) {
  return _uniqueId(prefix);
}
